import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { CompaniesDepartment } from 'src/app/lem/models/departments/departments';
import { DepartmentsService } from '../../../service/departments.service';
import { CompanyService } from 'src/app/lem/pages/amministrazione/service/company.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Role } from 'src/app/lem/models/common/role';
import { zip } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CompanyDepartmentMember, RequestCompanyDepartmentMember } from 'src/app/lem/models/departments/member/member';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { ModalMemberComponent } from '../../../components/modal-member/modal-member.component';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { ACTION_DELETE, ACTION_DELETE_EMPLOYMENT_RELATIONSHIP, ACTION_EDIT, ACTION_SAVE, ACTION_TRANSFER, MEMBERS, PHYSICAL_ENTITY } from '../../../constants/constants';
import { Pathbar } from 'src/app/lem/models/common/pathbar';
import { PathbarLemComponent } from 'src/app/lem/utils/components/pathbar-lem/pathbar-lem.component';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-detail-department-page',
  templateUrl: './detail-department-page.component.html',
  styleUrls: ['./detail-department-page.component.css'],
  host:{'[attr.id]': '\'content\''}
})
export class DetailDepartmentPageComponent implements OnInit {

  idDepartment: string;
  departmentSelected:CompaniesDepartment;
  roles : PaginatedResponse<Role>;
  members: PaginatedResponse<CompanyDepartmentMember>;
  responsibles: PaginatedResponse<CompanyDepartmentMember>;
  pagableMembers:Pagable;
  pagableResponsables:Pagable;
  listMembersID : string[] = [];
  pathbars: Pathbar[] = [];
  resetCurrentPage: boolean = false;

  constructor(private modal : DialogService,
    private departmentsService : DepartmentsService,
    private viewManager : ViewManagerService,
    private route:ActivatedRoute) { }

  ngOnInit() {
    this.viewManager.svuotaMenu();

    this.pagableMembers = new Pagable();
    this.pagableResponsables = new Pagable();
    this.route.params.subscribe((params: Params) =>{
      this.idDepartment = params['id'];
      if(this.idDepartment){
        this.loadPage();
      }
    });
    this.populatePathbar();

  }

  addMembro(){
    const ref = this.modal.open(ModalMemberComponent,{
      data : {
        style: {width: "50%"},
        departmentSelected : this.departmentSelected,
        roles : this.roles,
        action : ACTION_SAVE,
        formSettings : {
          formEdit : false,
          formData : ""
        },
        listMembersID : this.listMembersID
      }
    })
    this.modalCloseEvent(ref);
  }

  onEdit(membro: CompanyDepartmentMember){
    const ref = this.modal.open(ModalMemberComponent,{
      data : {
        style: {width: "50%"},
        departmentSelected : this.departmentSelected,
        roles : this.roles,
        member: membro,
        action : ACTION_EDIT,
        formSettings : {
          formEdit : true,
          formData : ""
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  onDelete(membro: CompanyDepartmentMember){
    let descName = '';
    if(membro.person.type === PHYSICAL_ENTITY){
      descName = membro.person.lastName + ' ' + membro.person.firstName;
    } else {
      descName = membro.person.name;
    }
    const ref = this.modal.open(ConfirmModalComponent,{
      data : {
        modalConfirm:{

          text:"Vuoi eliminare   " + descName + "?" ,
          data : membro,
          action : ACTION_DELETE
        },
        style: {width: "30%"},
        title:"Eliminazione Membro",
      }
    })
    this.modalCloseEvent(ref);
  }


  onFinish(membro: CompanyDepartmentMember){
    let descName = '';
    if(membro.person.type === PHYSICAL_ENTITY){
      descName = membro.person.lastName + ' ' + membro.person.firstName;
    } else {
      descName = membro.person.name;
    }

    let request =  {
      memberID :membro.id,
      personId:membro.person.id,
      roleId:membro.role.id,
      isInChargeOf:membro.isInChargeOf,
      validFrom: membro.validFrom,
      validTo: new Date()
    }
    const ref = this.modal.open(ConfirmModalComponent,{
      data : {
        modalConfirm:{

          text:"Vuoi concludere il rapporto lavorativo con  " + descName + "?" ,
          departmentSelected : this.departmentSelected,
          roles : this.roles,
          data : request,
          action : ACTION_DELETE_EMPLOYMENT_RELATIONSHIP
        },
        style: {width: "30%"},
        title:"Eliminazione Membro",
      }
    })
    this.modalCloseEvent(ref);
  }

  onTransfer(membro: CompanyDepartmentMember){
    this.departmentsService.getAll(undefined,undefined, undefined).subscribe(response => {

      const departments = response.items;
      let departmentsFiltered = departments.filter(dep => this.departmentSelected.id !== dep.id);
      const ref = this.modal.open(ModalMemberComponent,{
        data : {
          style: {width: "50%"},
          departmentSelected : this.departmentSelected,
          roles : this.roles,
          member: membro,
          action : ACTION_TRANSFER,
          departments : departmentsFiltered,
          formSettings : {
            formEdit : true,
            formData : ""
          }
        }
      })

      this.modalCloseEvent(ref);

    })
  }

  retrievePagable(pagable:Pagable , type:string){
    if(type === MEMBERS){
      this.pagableMembers = pagable;
      this.getAllMembers();
    } else {
      this.pagableResponsables = pagable;
      this.getAllResponsible();
    }
  }

  private modalCloseEvent (ref: DialogRef) {
    ref.afterClosed.pipe(
      filter(response => response)
    ).subscribe((data)=>{
      if(data.action === ACTION_SAVE){
        this.departmentsService.createMember(this.departmentSelected.company.id, this.departmentSelected.joinId , data.data).pipe(
          map(data => {
            this.loadInfoPage();
          })
        ).subscribe();
      } else if(data.action === ACTION_EDIT){
        this.departmentsService.updateMember(this.departmentSelected.company.id, this.departmentSelected.joinId ,data.member.id, data.data).pipe(
          map(data => {
            this.loadInfoPage();
          })
        ).subscribe();
      } else if(data.action === ACTION_TRANSFER){
        this.departmentsService.transferMember(this.departmentSelected.company.id,
                                              this.departmentSelected.joinId ,
                                              data.member.id,
                                              data.departmentSelectedTo.joinId,
                                              data.data).pipe(
          map(data => {
            this.loadInfoPage();
          })
        ).subscribe();
      } else if(data.modalEvent && ACTION_DELETE ===  data.action){
        this.departmentsService.deleteMember(this.departmentSelected.company.id, this.departmentSelected.joinId , data.data.id).pipe(
          map(data => {
            this.loadInfoPage();
          })
        ).subscribe();
      } else if(data.modalEvent && ACTION_DELETE_EMPLOYMENT_RELATIONSHIP ===  data.action){
        const infoDelete = data.data;
        let request = {
          personId:infoDelete.personId,
          roleId:infoDelete.roleId,
          isInChargeOf:infoDelete.isInChargeOf,
          validFrom: infoDelete.validFrom,
          validTo: infoDelete.validTo
        }
        this.departmentsService.updateMember(this.departmentSelected.company.id, this.departmentSelected.joinId ,infoDelete.memberID, request).pipe(
          map(data => {
            this.loadInfoPage();
          })
        ).subscribe();
      }
    });
  }

  private loadInfoPage() {
    this.getAllMembers();
    this.getAllResponsible();
    this.getAllMembersAssociated();
  }

  private loadPage(){
    const obsFind = this.departmentsService.fineById(this.idDepartment);
    const zipObs = zip(
      obsFind
    );

    zipObs.subscribe({
      next:(data)=>{
        this.departmentSelected = data[0];
        this.loadInfoPage();
      },
      error:()=>{}
    });
  }



  private getAllMembers() {
    if (this.departmentSelected) {
      let params = new Map()
      params.set("isInChargeOf","false");
      this.departmentsService.getAllMembers(this.departmentSelected.company.id, this.departmentSelected.joinId, params, this.pagableMembers).subscribe({
        next: (data) => {
          this.members = data;
        },
        error: () => { }
      });
    }
  }

  private getAllResponsible() {
    if (this.departmentSelected) {
      let params = new Map()
      params.set("isInChargeOf","true");
      this.departmentsService.getAllMembers(this.departmentSelected.company.id, this.departmentSelected.joinId, params, this.pagableResponsables).subscribe({
        next: (data) => {
          this.responsibles = data;
        },
        error: () => { }
      });
    }
  }


  private getAllMembersAssociated(){
    this.departmentsService.getAllMembersAssociated().subscribe({
      next: (data) => {
        this.listMembersID = data;
      },
      error: () => { }
    });
  }

  private populatePathbar(){
    this.pathbars.push({path: "/dipartimenti",title: "Vai ai dipartimenti",description: "Dipartimenti"});
    this.pathbars.push({path: "/dipartimenti/dettaglio/"+this.idDepartment, title: "", description: "Gestione dipartimento"});
  }

  refreshResponsible(pagination?: Pagination) {
    if(pagination) {
      this.pagableResponsables.page = pagination.getCurrentPage();
      this.pagableResponsables.size = pagination.getItemsPerPage();
    }
    this.getAllResponsible();
    this.resetCurrentPage = false;
  }

  refreshMembers(pagination?: Pagination) {
    if(pagination) {
      this.pagableMembers.page = pagination.getCurrentPage();
      this.pagableMembers.size = pagination.getItemsPerPage();
    }
    this.getAllMembers();
    this.resetCurrentPage = false;

  }
}
